The high-level description of the HTTP request's result.

Currently, four codes are defined:

- `BadResponse` indicates the subscription endpoint returned a non-2xx HTTP response.
- `InvalidUrl` indicates the subscription URL did not pass validation.
- `RequestTimeout` indicates the subscription endpoint took more than 10 seconds to respond.
- `Success` indicates the subscription endpoint returned a 2xx HTTP response.
